import React, {useEffect, useState} from "react";
import {OrganizationUnitSubscriptionsOverview} from "./OrganizationUnitSubscriptionsOverview";
import {
    OrganizationUnitSubscriptionsRowOverview,
    withCachedOrganizationUnitSubscriptionsRowOverview,
} from "./OrganizationUnitSubscriptionsRowOverview";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import {grey} from "@material-ui/core/colors";
import {useOrganization} from "../organizations/organization-context";
import {
    getOrganizationUnit,
    getOrganizationUnitCount,
    searchOrganizationUnitChildren
} from "../../api/organization-unit-functions";
import {run} from "../../utils/function-util";
import {LazyLoadedList} from "../ui/LazyLoadedList";
import {useMediaQuery} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    childDivider: {
        'background-color': grey[400]
    },
    overviewChildrenList: {
        overflowY: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    orgUnitChildrenContainer: {
        flex: '1 1 auto',
        'overflow-x': 'hidden'
    }
}));
export const OrganizationUnitOverview = ({organizationUnitId, filter, onCloseOverview}: any) => {
    const classes = useStyles();
    const [currentOrganization] = useOrganization();
    const [organizationUnit, setOrganizationUnit] = useState<any>(undefined);
    const [organizationUnitChildrenCount, setOrganizationUnitChildrenCount] = useState<number>(0);
    const [organizationUnitChildren, setOrganizationUnitChildren] = useState<any[]>([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const loadChildren = async (start: any, end: any) => {
        if (!currentOrganization || !organizationUnitId || !organizationUnit) {
            return Promise.resolve({items: []});
        }
        if (end <= start)
            return Promise.resolve({items: []});
        const size = end - start + 1;
        const children = await searchOrganizationUnitChildren(currentOrganization.id, organizationUnitId, start, size, filter);
        setOrganizationUnitChildren(prev => {
            return [...prev.slice(0, start), ...children, ...prev.slice(end + 1)];
        });
    };
    useEffect(run(async () => {
        setOrganizationUnit(undefined);
        if (!organizationUnitId || !currentOrganization) {
            return Promise.resolve(undefined);
        }
        const orgUnit = await getOrganizationUnit(currentOrganization.id, organizationUnitId);
        return orgUnit;
    }, (orgUnit: any) => {
        setOrganizationUnit(orgUnit);
    }), [organizationUnitId, currentOrganization]);

    useEffect(run(async () => {
        if (!currentOrganization || !organizationUnit) {
            return Promise.resolve(0);
        }
        setOrganizationUnitChildrenCount(0);
        setOrganizationUnitChildren([]);
        const childrenCount = await getOrganizationUnitCount(currentOrganization.id, organizationUnit.id, filter);
        return childrenCount;
    }, (count: number) => {
        setOrganizationUnitChildren(new Array(count).fill(null));
        setOrganizationUnitChildrenCount(count);
        count === 1 && loadChildren(0, 1);
    }), [organizationUnit, filter]);

    const CachedOrganizationUnitSubscriptionsRowOverview = withCachedOrganizationUnitSubscriptionsRowOverview();

    if (!currentOrganization) return null;

    const renderChildByIndex = ({index, style}: any) => {
        const orgUnit = organizationUnitChildren[index];
        return (<div key={`child-org-unit-overview-${orgUnit && orgUnit.id || index}`} style={style}>
            <Divider className={classes.childDivider}/>
            <CachedOrganizationUnitSubscriptionsRowOverview organizationUnitId={orgUnit && orgUnit.id || null}
                                                            recursive={true}/>
        </div>);
    };
    const isLoaded = (index: any) => organizationUnitChildren && !!organizationUnitChildren[index];
    return (<React.Fragment>
        <OrganizationUnitSubscriptionsOverview organizationUnit={organizationUnit} onCloseOverview={onCloseOverview}/>
        {!isMobile &&
        <div className={classes.overviewChildrenList}>
            <OrganizationUnitSubscriptionsRowOverview organizationUnitId={organizationUnitId} recursive={false}/>
            <div className={classes.orgUnitChildrenContainer}>
                {organizationUnit &&
                (organizationUnit?.id === organizationUnitId) &&
                organizationUnitChildrenCount > 0 &&
                <LazyLoadedList itemCount={organizationUnitChildrenCount} item={renderChildByIndex}
                                isItemLoaded={isLoaded} loadMoreItems={loadChildren} itemSize={60}/>}
            </div>
        </div>}

    </React.Fragment>);
};
